var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRightThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#263740",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1382 436L1390 444 1382 452",
    transform: "translate(-1381 -435)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightThin);
export default __webpack_public_path__ + "static/media/ic_arrow_right_thin.09f11389c5343ec87896e4ae3ecaa70a.svg";
export { ForwardRef as ReactComponent };